function SchedulePadSettings() {
  return (
    <div>
      <h1>Settings</h1>
    </div>
  );
}

export default SchedulePadSettings;
